import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=5a543ba2&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports